import styled from '@emotion/styled';

const TableHolder = styled.div`
  display: flex;
  flex-direction: column;
`;

// TODO: Not used
const TableContents = styled.div``;
const HeightFixer = styled.div``;
const Placeholder = styled.div``;
const PlaceholderContents = styled.div``;

export { HeightFixer, Placeholder, PlaceholderContents, TableContents, TableHolder };
